import React, { useState } from "react";
import { FileSpreadsheet, Download, Calendar, Loader2 } from "lucide-react";
import apiService from "../services/api";
import "../styles/GoldCleanReport.css";

const KoralReport = () => {
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // Generate month options for the last 12 months
  const getMonthOptions = () => {
    const options = [];
    const now = new Date();
    for (let i = 0; i < 12; i++) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const value = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}`;
      const label = date.toLocaleDateString("he-IL", {
        year: "numeric",
        month: "long",
      });
      options.push({ value, label });
    }
    return options;
  };

  const handleExport = async () => {
    if (!selectedMonth) {
      setError("יש לבחור חודש");
      return;
    }

    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await apiService.exportKoralReport(selectedMonth);

      // Create blob and download
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `koral_report_${selectedMonth.replace("-", "_")}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      console.error("Export error:", err);
      setError(err.message || "שגיאה בייצוא הקובץ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='gold-clean-report-container'>
      <div className='report-header'>
        <div className='header-icon'>
          <FileSpreadsheet size={32} />
        </div>
        <div className='header-text'>
          <h1>דוח קורל</h1>
          <p>ייצוא דוח אקסל לפי לקוחות וקבלנים</p>
        </div>
      </div>

      <div className='report-card'>
        <div className='card-content'>
          <div className='form-section'>
            <label className='form-label'>
              <Calendar size={18} />
              בחר חודש
            </label>
            <select
              className='month-select'
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              disabled={loading}
            >
              {getMonthOptions().map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className='info-section'>
            <h3>מבנה הקובץ:</h3>
            <ul>
              <li>גיליון לכל לקוח</li>
              <li>גיליונות קבלנים (מוניר, איברהים, איתן שמיר, ואי גי אס)</li>
              <li>פירוט שעות, תעריפים ותשלומים</li>
            </ul>
          </div>

          {error && <div className='error-message'>{error}</div>}

          {success && <div className='success-message'>הקובץ הורד בהצלחה!</div>}

          <button
            className='export-button'
            onClick={handleExport}
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader2 size={20} className='spinning' />
                מייצא...
              </>
            ) : (
              <>
                <Download size={20} />
                ייצוא לאקסל
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default KoralReport;
